<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{$ml.get('shared.deviceOperations')}}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{$ml.get('shared.dashboard')}}</span>
        </li>
        <li>
          <i class="fa fa-book"></i>
          <span>{{$ml.get('shared.definitions')}}</span>
        </li>
        <li>
          <span>{{$ml.get('shared.deviceOperations')}}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-4">
          <div class="box box-primary">
            <div class="box-header">
              <h3 class="box-title">
                <span>{{$ml.get('deviceOperations.addTask')}}</span>
                <a style="text-align:right;" @click="checkReaders()">
                  <span
                    style="font-size:15px;"
                    v-text="isCheck == true ? this.$ml.get('general.removeAll') : this.$ml.get('general.selectAll')"
                  ></span>
                </a>
              </h3>
              <div class="pull-right"></div>
            </div>
            <div class="box-body">
              <input
                type="text"
                :placeholder="$ml.get('general.search')"
                v-model="searchText"
                class="form-control"
                autocomplete="false"
                style="margin-bottom:10px;"
              />
              <div class="row" style="margin-bottom:10px; margin-right:5px;">
                <div class="col-sm-12">
                  <div
                    v-show="readerList.length > 0"
                    class="table-responsive no-padding"
                    :style="windowReaderHeightSize"
                  >
                    <table class="table table-hover">
                      <tbody>
                        <tr v-for="reader in readerList" :key="reader.id">
                          <td class="checkbox">
                            <label style="margin-left:20px;">
                              <input
                                type="checkbox"
                                name="check"
                                :checked="reader.check"
                                @change="reader.check==true ? reader.check=false : reader.check=true"
                              />
                              {{reader.ipAddress}} | {{reader.readerNo}} - {{reader.name}}
                            </label>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-show="readerList.length == 0" class="callout callout-info">
                    <i class="fa fa-info-circle"></i>
                    {{$ml.get('deviceOperations.deviceNotRecord')}}
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>{{$ml.get('deviceOperations.startTime')}}</label>
                    <input type="datetime-local" class="form-control" v-model="work.date" />
                  </div>
                </div>
              </div>
              <div class="row" style="margin-bottom:10px;">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>{{$ml.get('deviceOperations.selectTask')}}</label>
                    <select @change="changeCommand($event)" class="form-control">
                      <option
                        value="0"
                        :selected="work.command == 0"
                      >{{$ml.get('deviceOperations.getMovementLogs')}}</option>
                      <option
                        value="1"
                        :selected="work.command == 1"
                      >{{$ml.get('deviceOperations.personSetAndDelete')}}</option>
                      <!--<option value="2" :selected="work.command == 2">{{$ml.get('deviceOperations.getPersons')}}</option>-->
                      <option
                        value="3"
                        :selected="work.command == 3"
                      >{{$ml.get('deviceOperations.sendBatchPersonData')}}</option>
                      <option
                        value="4"
                        :selected="work.command == 4"
                      >{{$ml.get('deviceOperations.updateTime')}}</option>
                      <!--<option value="5" :selected="work.command == 5">{{$ml.get('deviceOperations.restart')}}</option>
                      <option value="6" :selected="work.command == 6">{{$ml.get('deviceOperations.removeAdminAuthorizes')}}</option>-->
                      <option
                        value="7"
                        :selected="work.command == 7"
                      >{{$ml.get('deviceOperations.removeAllPerson')}}</option>
                      <option
                        value="8"
                        :selected="work.command == 8"
                      >{{$ml.get('deviceOperations.sendAuthorityGroups')}}</option>
                      <option
                        value="9"
                        :selected="work.command == 9"
                      >{{$ml.get('deviceOperations.sendBatchPlates')}}</option>
                      <option
                        value="10"
                        :selected="work.command == 10"
                      >{{$ml.get('deviceOperations.sendPlate')}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="row" style="margin-bottom:10px;">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>{{$ml.get('deviceOperations.repeatDaily')}}</label>
                    <div class="checkbox">
                      <label style="margin-left:20px;">
                        <input
                          type="checkbox"
                          name="isRepeated"
                          :checked="work.isRepeated"
                          @click="work.isRepeated = !work.isRepeated"
                        />
                        {{$ml.get('deviceOperations.applyRepeatDaily')}}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div v-show="work.isRepeated" class="row" style="margin-bottom:10px;">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>{{$ml.get('deviceOperations.repetitionInterval')}}</label>
                    <div class="input-group">
                      <input
                        type="number"
                        class="form-control text-center"
                        min="0"
                        max="350"
                        v-model="work.day"
                      />
                      <label class="input-group-addon">{{$ml.get('deviceOperations.oneTimePerDay')}}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <button
                    v-show="authControl == 0"
                    type="button"
                    class="btn btn-primary "
                    style="display:inline-block;width:100%;"
                    @click="saveWork()"
                  >
                    <span>{{$ml.get('deviceOperations.sendCommand')}}</span>
                    <i class="fa fa-arrow-circle-right"></i>
                  </button>
                </div>
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoadingDetail">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
        <div class="col-sm-8">
          <div class="box box-primary">
            <div class="box-header">
              <i class="fa fa-random"></i>
              <h3 class="box-title">
                <span>{{$ml.get('deviceOperations.activeTaskList')}} : {{workList.length}}</span>
              </h3>
              <div class="box-tools pull-right">
                <button @click="getWorkList()" class="btn btn-primary btn-sm ">{{$ml.get('general.refreshScreen')}}</button>
              </div>
            </div>
            <div class="box-body">
              <div
                v-show="workList.length > 0"
                class="table-responsive no-padding"
                :style="windowHeightSize"
              >
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>{{$ml.get('deviceOperations.person')}}</th>
                      <th>{{$ml.get('deviceOperations.task')}}</th>
                      <th>{{$ml.get('deviceOperations.device')}}</th>
                      <th>{{$ml.get('deviceOperations.taskTime')}}</th>
                      <th>{{$ml.get('deviceOperations.repeatDay')}}</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(worke, index) in workList" :key="worke.terminalWorkId" class="rows">
                      <td>
                        <strong>{{index + 1}}</strong>
                      </td>
                      <td>
                        <span>{{worke.employeeName}}</span>
                      </td>
                      <td>
                        <span
                          v-show="worke.command == 0"
                          class="label label-warning"
                        >{{$ml.get('deviceOperations.getMovementLogs')}}</span>
                        <span
                          v-show="worke.command == 1"
                          class="label label-success"
                        >{{$ml.get('deviceOperations.personSetAndDelete')}}</span>
                        <span
                          v-show="worke.command == 2"
                          class="label label-warning"
                        >{{$ml.get('deviceOperations.getPersons')}}</span>
                        <span
                          v-show="worke.command == 3"
                          class="label label-success"
                        >{{$ml.get('deviceOperations.sendBatchPersonData')}}</span>
                        <span
                          v-show="worke.command == 4"
                          class="label label-primary"
                        >{{$ml.get('deviceOperations.updateTime')}}</span>
                        <span
                          v-show="worke.command == 5"
                          class="label label-danger"
                        >{{$ml.get('deviceOperations.restart')}}</span>
                        <span
                          v-show="worke.command == 6"
                          class="label label-danger"
                        >{{$ml.get('deviceOperations.removeAdminAuthorizes')}}</span>
                        <span
                          v-show="worke.command == 7"
                          class="label label-danger"
                        >{{$ml.get('deviceOperations.removeAllPerson')}}</span>
                        <span
                          v-show="worke.command == 8"
                          class="label label-danger"
                        >{{$ml.get('deviceOperations.sendAuthorityGroups')}}</span>
                        <span
                          v-show="worke.command == 9"
                          class="label label-info"
                        >{{$ml.get('deviceOperations.sendBatchPlates')}}</span>
                        <span
                          v-show="worke.command == 10"
                          class="label label-info"
                        >{{$ml.get('deviceOperations.sendPlate')}}</span>
                      </td>
                      <td>
                        <span>{{getReader(worke.readerId)}}</span>
                      </td>
                      <td>
                        <span>{{worke.date | toDateFormatGet}}</span>
                      </td>
                      <td>
                        <span v-show="!worke.isRepeated">{{$ml.get('deviceOperations.noRepeat')}}</span>
                        <span v-show="worke.isRepeated">{{worke.day}}</span>
                      </td>
                      <td>
                        <button
                          v-show="authControl == 0"
                          class="btn btn-danger btn-sm"
                          data-toggle="modal"
                          data-target="#modal-sil"
                          @click="selectWork(worke.terminalWorkId)"
                        >
                          <i class="fa fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-show="workList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i>
                {{$ml.get('deviceOperations.activeTaskNotRecord')}}
              </div>
            </div>
            <div class="overlay" id="load" :hidden="!isLoading">
              <i class="fa fa-refresh fa-spin"></i>
            </div>
          </div>
        </div>
        <!-- /.MODAL START-->
        <div class="modal modal-danger fade" id="modal-sil">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">×</span>
                </button>
                <h4 class="modal-title">
                  <span>{{$ml.get('general.delete')}}</span>
                </h4>
              </div>
              <div class="modal-body">
                <div>
                  {{selectedWork.date | toDateFormatGet}}
                  <span
                    v-show="selectedWork.command == 0"
                    class="label label-warning"
                  >{{$ml.get('deviceOperations.getMovementLogs')}}</span>
                  <span
                    v-show="selectedWork.command == 1"
                    class="label label-success"
                  >{{$ml.get('deviceOperations.personSetAndDelete')}}</span>
                  <span
                    v-show="selectedWork.command == 2"
                    class="label label-warning"
                  >{{$ml.get('deviceOperations.getPersons')}}</span>
                  <span
                    v-show="selectedWork.command == 3"
                    class="label label-success"
                  >{{$ml.get('deviceOperations.sendBatchPersonData')}}</span>
                  <span
                    v-show="selectedWork.command == 4"
                    class="label label-primary"
                  >{{$ml.get('deviceOperations.updateTime')}}</span>
                  <span
                    v-show="selectedWork.command == 5"
                    class="label label-danger"
                  >{{$ml.get('deviceOperations.restart')}}</span>
                  <span
                    v-show="selectedWork.command == 6"
                    class="label label-danger"
                  >{{$ml.get('deviceOperations.removeAdminAuthorizes')}}</span>
                  <span
                    v-show="selectedWork.command == 7"
                    class="label label-danger"
                  >{{$ml.get('deviceOperations.removeAllPerson')}}</span>
                  <span
                    v-show="selectedWork.command == 8"
                    class="label label-danger"
                  >{{$ml.get('deviceOperations.sendAuthorityGroups')}}</span>
                  <span
                    v-show="selectedWork.command == 9"
                    class="label label-info"
                  >{{$ml.get('deviceOperations.sendBatchPlates')}}</span>
                  <span
                    v-show="selectedWork.command == 10"
                    class="label label-info"
                  >{{$ml.get('deviceOperations.sendPlate')}}</span>
                </div>
                <br />
                <p></p>
                <span>{{$ml.get('deviceOperations.isContinueTaskDelete')}}</span>
              </div>
              <div class="modal-footer">
                <button type="button" class="btn btn-danger" data-dismiss="modal">
                  <i class="fa fa-remove"></i>
                  <span>{{$ml.get('general.cancel')}}</span>
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  data-dismiss="modal"
                  @click="deleteWork(selectedWork.terminalWorkId)"
                >
                  <i class="fa fa-trash"></i>
                  <span>{{$ml.get('general.delete')}}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- /.MODAL END -->
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data() {
    return {
      windowHeight: window.innerHeight,
      isLoading: false,
      isLoadingDetail: false,
      searchText: "",
      readers: [],
      work: {
        date: null,
        isRepeated: false,
        day: 0,
        command: 0,
        terminalsAndReaders: []
      },
      selectedWork: {
        terminalWorkId: null,
        command: null,
        date: null,
        readerId: null
      },
      isCheck: false,
      works: []
    };
  },
  filters: {
    toDateFormatGet(str) {
      if (!str) {
        return "";
      }
      str = new Date(str);
      var gun = (str.getDate() < 10 ? "0" : "") + str.getDate();
      var ay = (str.getMonth() < 9 ? "0" : "") + (str.getMonth() + 1);
      var yil = str.getFullYear();
      var saat = str.getHours() < 10 ? "0" + str.getHours() : str.getHours();
      var dakika =
        str.getMinutes() < 10 ? "0" + str.getMinutes() : str.getMinutes();
      return gun + "." + ay + "." + yil + " " + saat + ":" + dakika;
    }
  },
  computed: {
    authControl() {
      return this.$store.getters.getAuthTanimlamalar;
    },
    readerList() {
      if (this.searchText) {
        return this.readers.filter(item => {
          return this.searchText
            .toUpperCase()
            .split(" ")
            .every(
              v =>
                item.showName.toUpperCase().includes(v)
            );
        });
      } else {
        return this.readers.sort((a, b) => {
          if (a.ipAddress < b.ipAddress) return -1;
          if (a.ipAddress > b.ipAddress) return 0;
        });
      }
    },
    workList() {
      return this.works.sort((a, b) => {
        if (a.date < b.date) return -1;
        if (a.date > b.date) return 0;
      });
    },
    windowHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 260;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    },
    windowReaderHeightSize() {
      if (this.windowHeight) {
        let height = this.windowHeight - 540;
        return "max-height:" + height + "px;overflow:auto;";
      } else {
        return "max-height:370px;overflow:auto;";
      }
    }
  },
  watch: {
    windowHeight(newHeight, oldHeight) {
      if (newHeight < 576) {
        //MOBİL
      } else {
        //WEB
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    onResize() {
      this.windowHeight = window.innerHeight;
    },
    getDefaultDate() {
      let toDay = new Date();
      var gun = (toDay.getDate() < 10 ? "0" : "") + toDay.getDate();
      var ay = (toDay.getMonth() < 9 ? "0" : "") + (toDay.getMonth() + 1);
      var yil = toDay.getFullYear();
      var saat =
        toDay.getHours() < 10 ? "0" + toDay.getHours() : toDay.getHours();
      var dakika =
        toDay.getMinutes() < 10 ? "0" + toDay.getMinutes() : toDay.getMinutes();
      if (this.work.date == null) {
        this.work.date = yil + "-" + ay + "-" + gun + "T" + saat + ":" + dakika;
      }
    },
    changeCommand(event) {
      this.work.command = event.target.value;
    },
    checkReaders() {
      this.isCheck = !this.isCheck;
      let aList = this.readers;
      aList.forEach(doc => {
        if (doc.check == !this.isCheck) {
          doc.check = this.isCheck;
        }
      });
    },
    getReader(id) {
      let aList = this.readers;
      let reader = aList.filter(function(reader) {
        return reader.readerId == id;
      });
      if (reader.length > 0) {
        return reader[0].name;
      } else {
        return "";
      }
    },
    getCheckReaderList() {
      let aList = this.readers;
      this.work.terminalsAndReaders = [];
      aList.forEach(doc => {
        if (doc.check == true) {
          this.work.terminalsAndReaders.push({
            terminalId: doc.terminalId,
            readerId: doc.readerId
          });
        }
      });
    },
    selectWork(id) {
      let aList = this.works;
      let work3 = aList.filter(function(work4) {
        return work4.terminalWorkId == id;
      });
      this.selectedWork.terminalWorkId = work3[0].terminalWorkId;
      this.selectedWork.command = work3[0].command;
      this.selectedWork.date = work3[0].date;
      this.selectedWork.readerId = work3[0].readerId;
    },
    async deleteWork(id) {
      try {
        this.isLoading = true;
        const response = await this.$axios
          .delete("/TerminalService/" + id)
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            }
            if (
              error.message == "Network Error" ||
              error.message == "Error: Network Error"
            ) {
              alertify.error(this.$ml.get("errors.connectionError"));
              this.isLoading = false;
              return;
            } else {
              console.error(error);
              alertify.error(error.message);
              this.isLoading = false;
              return;
            }
          });
        this.getWorkList();
        if (response.status == 200) {
          alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
        } else {
          alertify.error(response.message);
        }
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası : " + error);
        this.isLoading = false;
      }
    },
    async saveWork() {
      if (this.work.date == null) {
        alertify.warning(this.$ml.get("deviceOperations.pleaseEnterADate"));
        return;
      }
      this.isLoadingDetail = true;
      await this.getCheckReaderList();
      try {
        let work2 = this.work;
        const response = await this.$axios
          .post("/TerminalService", {
            date: work2.date,
            isRepeated: work2.isRepeated,
            command: work2.command,
            day: work2.day,
            terminalsAndReaders: work2.terminalsAndReaders
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            }
            if (
              error.message == "Network Error" ||
              error.message == "Error: Network Error"
            ) {
              alertify.error(this.$ml.get("errors.connectionError"));
              this.isLoadingDetail = false;
              return;
            } else {
              console.error(error);
              alertify.error(error.message);
              this.isLoadingDetail = false;
              return;
            }
          });
        if (response.status == 200) {
          alertify.success(this.$ml.get("alerts.savedSuccessfully"));
        } else {
          alertify.error(response.message);
        }
        this.getWorkList();
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası : " + error);
        this.isLoadingDetail = false;
      }
    },
    async getReaders() {
      try {
        this.isLoadingDetail = true;
        const readers = [];
        const response = await this.$axios
          .get("/Terminal/GetReaders")
          .then(response => {
            response.data.forEach(doc => {
              if (
                doc.doorType == 0 ||
                doc.doorType == 1 ||
                doc.doorType == 2 ||
                doc.doorType == 3 ||
                doc.doorType == 5
              ) {
                readers.push({
                  readerNo: doc.readerNo,
                  readerId: doc.readerId,
                  terminalId: doc.terminalId,
                  terminalNo: doc.terminalNo,
                  ipAddress: doc.ipAddress,
                  name: doc.name,
                  showName: doc.ipAddress + " | " + doc.readerNo + " - " + doc.name,
                  check: false
                });
              }
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            }
            if (
              error.message == "Network Error" ||
              error.message == "Error: Network Error"
            ) {
              alertify.error(this.$ml.get("errors.connectionError"));
              this.isLoadingDetail = false;
              return;
            } else {
              console.error(error);
              alertify.error(error.message);
              this.isLoadingDetail = false;
              return;
            }
          });
        this.readers = readers;
        this.isLoadingDetail = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoadingDetail = false;
      }
    },
    async getWorkList() {
      try {
        this.isLoading = true;
        const works = [];
        const response = await this.$axios
          .get("/TerminalService")
          .then(response => {
            response.data.forEach(doc => {
              works.push({
                terminalWorkId: doc.terminalWorkId,
                date: doc.date,
                readerId: doc.readerId,
                isRepeated: doc.isRepeated,
                command: doc.command,
                day: doc.day,
                employeeName: doc.employeeName
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            }
            if (
              error.message == "Network Error" ||
              error.message == "Error: Network Error"
            ) {
              alertify.error(this.$ml.get("errors.connectionError"));
              this.isLoading = false;
              return;
            } else {
              console.error(error);
              alertify.error(error.message);
              this.isLoading = false;
              return;
            }
          });
        this.works = works;
        this.isLoading = false;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
        this.isLoading = false;
      }
    },
    async getAuthControl() {
      if (this.authControl == 1) {
        alertify.warning(
          this.$ml.get("alerts.youAreOnlyAuthorizedToViewThisPage")
        );
      }
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  async created() {
    await this.getAuthControl();
    await this.getReaders();
    await this.getWorkList();
    await this.getDefaultDate();
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/deviceOperations/DeviceOperations.vue